import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const updateWhatsappConversationAiFirst = async (domain: string, isEnabled: boolean): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `whatsapp-conversation-ai-first`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        params: { isEnabled },
        domain,
    });
}
